'use strict';

(function ($) {
	var grecaptchaValidation = function grecaptchaValidation(ev) {
		if ($(ev.target).find('div.g-recaptcha').length == 0) return false;

		if (typeof grecaptcha != 'undefined' && grecaptcha.getResponse() == 0) {
			ev.preventDefault();
			$(ev.target).find('div.g-recaptcha').addClass('is-invalid-input');
			$(ev.target).find('div.g-recaptcha').next('.form-error').addClass('is-visible');
		} else {
			$(ev.target).find('div.g-recaptcha').removeClass('is-invalid-input');
			$(ev.target).find('div.g-recaptcha').next('.form-error').removeClass('is-visible');
		};
	};

	$(document).on('forminvalid.zf.abide', function (ev, frm) {
		grecaptchaValidation(ev);
	}).on('submit', function (ev, frm) {
		grecaptchaValidation(ev);
	});

	var grecaptchaCallback = function grecaptchaCallback(response) {
		if (response) {
			$('div.g-recaptcha.is-invalid-input').removeClass('is-invalid-input');
			$('div.g-recaptcha').next('.form-error').removeClass('is-visible');
		}
	};
})(jQuery);